import { type Resident, ResidentStatus } from '@lmc/ts-common'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Actions from '../../../actions'
import { getNominative } from '../../../common/utils'
import ListHeaderSearch from '../../../LEGACY/ListHeaderSearch'
import Operations from '../../../operations'
import { ResidentProfileImportantPeople } from '../../../screens/Residents/screens/ResidentProfileScreen/_legacyReidentProfileScreen/components'

// LEGACY JS components without TypeScript declarations
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AnyListHeaderSearch = ListHeaderSearch as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AnyResidentProfileImportantPeople = ResidentProfileImportantPeople as any

interface RootState {
  data: {
    carers: any[]
    residents: Resident[]
  }
  global: {
    home: {
      familySetupComplete: boolean
      preferredPeopleNominative: string
    }
  }
}

const Container = styled.div`
  width: 100%;
`

const ResidentSectionContainer = styled.div`
  display: block;
  margin-bottom: 50px;
  margin-top: 50px;
`

const SearchBoxParentContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
`

const ResidentsContainer = styled.div`
  width: 100%;
`

export function FamilyInviteWizard() {
  const dispatch = useDispatch()
  const [search, setSearch] = useState('')

  const carers = useSelector((state: RootState) => state.data.carers)
  const familySetupComplete = useSelector(
    (state: RootState) => state.global.home.familySetupComplete
  )
  const preferredPeopleNominative = useSelector(
    (state: RootState) => state.global.home.preferredPeopleNominative
  )
  const residents = useSelector<RootState, Resident[]>(
    (state) =>
      state?.data?.residents?.filter((r) => r.status === ResidentStatus.active),
    shallowEqual
  )

  if (!preferredPeopleNominative) {
    return null
  }

  const preferredTerm = getNominative(
    preferredPeopleNominative,
    'Resident'
  ).toLowerCase()

  const pattern = new RegExp(
    search.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
    'i'
  )
  const filteredResidents = residents?.filter((res) =>
    `${res.name.first} ${res.name.last}`.match(pattern)
  )

  const openFamilyInviteModal = (contact: any, index: number, profile: any) => {
    dispatch(
      Actions.openModal({
        modalId: 'inviteFamily',
        data: {
          importantContact: contact,
          index,
          residentId: profile.id,
          residentName: {
            first: profile.name.first,
            last: profile.name.last
          }
        }
      })
    )
  }

  const resendInvite = (userId: string, cb: () => void) =>
    dispatch(Operations.resendInvite(userId, cb))

  return (
    <Container>
      <SearchBoxParentContainer>
        <AnyListHeaderSearch
          handleChange={(e: { target: { value: string } }) =>
            setSearch(e.target.value)
          }
          handleClear={() => setSearch('')}
          inputStyle={{ fontSize: 16 }}
          placeholder={`Search ${preferredTerm}'s name`}
          style={{ flex: 1 }}
          value={search}
        />
      </SearchBoxParentContainer>
      <ResidentsContainer>
        {filteredResidents?.length > 0 ? (
          filteredResidents.map((resident) => (
            <ResidentSectionContainer key={resident.id}>
              <AnyResidentProfileImportantPeople
                carers={carers}
                family
                familySetupComplete={familySetupComplete}
                marginTop={10}
                openFamilyInviteModal={openFamilyInviteModal}
                profile={resident}
                resendInvite={resendInvite}
                residentName={`${resident.name.first} ${resident.name.last}`}
                showGP={false}
              />
            </ResidentSectionContainer>
          ))
        ) : (
          <EmptyState
            description={`No ${preferredTerm}s found`}
            icon={<NoDataIcon />}
            title="Shoot... No data to show you"
          />
        )}
      </ResidentsContainer>
    </Container>
  )
}

export default FamilyInviteWizard
